import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpEditExperienceShellItineraryOptions,
	httpEditExperienceShellItinerary
} from '../http/experience-shell.http'
import type { Experience } from '../types'

export const useEditExperienceItinerary = ({
	urlParams,
	options
}: {
	urlParams: HttpEditExperienceShellItineraryOptions['urlParams']
	options?: Omit<
		UseMutationOptions<
			Experience,
			unknown,
			HttpEditExperienceShellItineraryOptions['payload'],
			unknown
		>,
		'mutationFn'
	>
}) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload) =>
			httpEditExperienceShellItinerary({
				urlParams,
				payload,
				params: { responseType: 'extended' }
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE, urlParams.experienceId]
			})
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE, urlParams.experienceId] },
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
